import { type AggregationFn } from "@tanstack/react-table";

import { isComparableNumber, round } from "./aggregationFnUtils";

export const median: AggregationFn<unknown> = (columnId, leafRows) => {
	const values = leafRows.flatMap((row) => {
		const value = row.getValue(columnId);
		if (!isComparableNumber(value)) {
			return [];
		}

		return [value];
	});

	if (!values.length) {
		return;
	}

	if (values.length === 1) {
		return values[0];
	}

	const mid = Math.floor(values.length / 2);
	const nums = values.sort((a, b) => a - b);
	const numAtMid = nums[mid];
	const numBeforeMid = nums[mid - 1];
	if (numAtMid === undefined || numBeforeMid === undefined) {
		return;
	}

	const median = values.length % 2 !== 0 ? numAtMid : (numBeforeMid + numAtMid) / 2;
	if (median === undefined) {
		return median;
	}
	return round(median);
};
